import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import {
  StyledRow,
  StyledListItem,
  StyledListItemText,
  StyledAvatar,
  StyledLeftIconButton,
  StyledRightIcons,
  StyledRowIconWrap,
  StyledDocumentItemBox,
} from './DocumentList.styles';
import { Loading } from 'global/styles';
import { get, first, last } from 'global/lib/lodash';
import SystemIcon from 'global/components/SystemIcon';
import { getIcon } from '../definitions';
import { useShowChanges } from 'global/hooks/useShowChanges';

export default function DocumentListItem(props) {
  const { match, selected, selectionMode, sideFilters, getSideFilterKeys, isDocumentPath } = props;
  const compact = !!isDocumentPath;
  const { showChangesOn } = useShowChanges();

  const item = get(props, 'item.0');
  const { documentExistsInParentEdition, documentParentExistsInParentEdition, documentParentInParentEdition } = item;
  const id = get(item, 'document.classification.id');
  const doc = last(get(props, 'path', '').split('document/'));
  const isStyleUpdated = showChangesOn && documentParentExistsInParentEdition;
  const isStyleNew = showChangesOn && !isStyleUpdated && !documentExistsInParentEdition;

  const content = {
    ...item,
    title: get(item, 'document.name', Loading),
    realm: get(item, 'realm.name', Loading),
    createdDate: get(item, 'createdAt', Loading),
    auditor: get(item, 'user.email', Loading),
    classificationName: get(item, 'document.classification.system.name', 'No Category Listed'),
  };

  const inSelectionMode = !!selectionMode;

  const active = doc == id;
  const activeDocFilterExists = useMemo(
    () =>
      Object.keys(get(sideFilters, `doctype.data`, {})).reduce((acc, filt) => {
        if (get(sideFilters, `doctype.data.${filt}.value`) === true) {
          return true;
        }
        return acc;
      }, false),
    [sideFilters]
  );

  const RightIcons = (keyIndex) => {
    const icos = [{ search: 'checklist' }, { search: 'step_by_step' }, { search: 'sowId' }, { search: 'library_file' }, { search: 'library_video' }, { search: 'interactive_document' }].filter((ico) =>
      get(props, 'item', []).find((pi) => get(pi, 'documentableType') === ico.search)
    );

    return (
      <StyledRightIcons compact={compact}>
        <StyledRow>
          {icos.map((ico) => {
            const isActive = get(sideFilters, `doctype.data.${ico.search}.value`);
            return (
              <StyledRowIconWrap key={`${ico.search}-${keyIndex}`} compact={compact} isActive={!!isActive} isInactive={!isActive && activeDocFilterExists}>
                {getIcon(ico.search)}
              </StyledRowIconWrap>
            );
          })}
        </StyledRow>
      </StyledRightIcons>
    );
  };

  const selectItem = (e) => {
    e.stopPropagation();
    e.preventDefault();
    props.onSelect({
      ...item,
      id,
    });
  };
  const to = () => {
    const activeTab = first(getSideFilterKeys());
    const obj = {
      ...(activeTab && { activeTab }),
      ...(showChangesOn && documentParentExistsInParentEdition && {
        documentParentId: get(documentParentInParentEdition, 'documentableId')
      }),
    };
    return `/library/${match.params.library}/document/${id}?${new URLSearchParams(obj).toString()}`;
  };

  const isSelected = get(selected, id);

  // PFM-2689: in modal/picker mode (onClick provided) the row must select in-place
  // and never client-side navigate. Omit `to` entirely so MUI v9 ListItemButton has
  // no route to follow; only render as a router Link in normal Library mode.
  const linkProps = props.onClick ? {} : { component: Link, to: to() };

  return (
    <StyledListItem
      {...linkProps}
      selected={active}
      compact={compact}
      onClick={!inSelectionMode ? (props.onClick ? (e) => props.onClick(content, e) : undefined) : selectItem}
    >
      <StyledLeftIconButton compact={compact} onClick={selectItem} size={compact ? 'small' : 'large'}>
        <StyledAvatar compact={compact} selectMode={inSelectionMode} isSelected={!!isSelected}>
          {inSelectionMode && isSelected ? (
            <CheckIcon fontSize={compact ? 'small' : 'medium'} />
          ) : (
            <SystemIcon systemId={get(content, 'document.classification.system.id')} />
          )}
        </StyledAvatar>
      </StyledLeftIconButton>
      {showChangesOn && (
        <StyledDocumentItemBox compact={compact} isStyleUpdated={isStyleUpdated} isStyleNew={isStyleNew} />
      )}
      <StyledListItemText compact={compact} noPad={!!content} primary={content.title} secondary={content.classificationName} />
      <RightIcons keyIndex={content.id} />
    </StyledListItem>
  );
}
